// extracted by mini-css-extract-plugin
module.exports = {"message":"G7OOu","buttons":"Ap0ze"};